const styles = theme => ({
  component_container: {
    position: 'relative',
  },
  calendar_container: {
    float: 'left',
    position: 'absolute',
    maxWidth: '400px',
    minWidth: '300px',
    background: '#fff',
    boxShadow: '10px 10px 40px rgba(0, 0, 0, 0.2)',
    borderRadius: '0px',
    overflow: 'hidden',
    padding: '24px',
    zIndex: 1,
  },
  select_dropdown: {
    position: 'relative',
    '& > button p': {
      textTransform: 'none',
      marginRight: '8px',
    },
  },
  dropdown_list: {
    height: '340px',
    background: '#fff',
    boxShadow: '10px 10px 40px rgba(0, 0, 0, 0.2)',
    position: 'absolute',
    top: '-20px',
    zIndex: 1,

    '& > p': {
      color: theme.palette.primary.adgmBlack,
      padding: '2px 0px',
      paddingLeft: '8px',
      cursor: 'pointer',
      transition: 'backgroundColor .1s',

      '&:hover': {
        backgroundColor: theme.palette.primary.grey,
      },
    },
  },
  months_dropdown: {
    width: '110px',
  },
  years_dropdown: {
    width: '90px',
    overflowY: 'scroll',
  },
  selected: {
    backgroundColor: theme.palette.primary.main,
    color: '#FFFFFF !important',
    '&:hover': {
      backgroundColor: `${theme.palette.primary.adgmHover} !important`,
    },
  },
  selectDisabled: {
    color: `${theme.palette.primary.darkGrey} !important`,
    cursor: 'default !important',
    '&:hover': {
      backgroundColor: '#FFFFFF !important',
    },
  },
  d_none: {
    display: 'none',
  },
  '@media (min-width:600px)': {
    calendar_container: { minWidth: '340px' },
  },
});

export default styles;
